import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import Header from '../master_root/header';
import Photosicon from '../assets/photos_icon.png';
// Icons
import { VscCalendar } from "react-icons/vsc"; 
import { GetAgoTime } from '../components/getAgoTime';
import { GetCalculateAge } from '../components/calculateAge'; 
import { LuBriefcaseBusiness } from "react-icons/lu"; 
import { CiLocationOn } from "react-icons/ci"; 
//page links    
import Navbar from '../master_root/Navbar';
import Footer from '../master_root/footer';
import { BiChat } from 'react-icons/bi';
export default function Hireeditors() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [UsersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Skillscategories, setSkillscategories] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState("0");
  const [selectedjobcategories, setSelectedjobcategories] = useState("0");
  const [isLoading, setIsLoading] = useState(true);
  const [islogoutLoading, setislogoutLoading] = useState(false);
  const [jobcategories, setJobcategories] = useState([]);

  // Fetch Skill Categories
  useEffect(() => {
    const fetchSkillscategoriesData = async () => {
      try {
        setIsLoading(true);
        let jq;
        if (selectedSkill === "0") {
          jq = query(collection(db, "postdata"), where("visibility", "==", true));
        } else {
          jq = query(
            collection(db, "postdata"),
            where("skillsId", "==", selectedSkill),
            where("visibility", "==", true)
          );
        }

        const querySnapshot = await getDocs(jq);
        const skillsCountMap = {};
        const skillIdsSet = new Set();

        querySnapshot.forEach(doc => {
          const skillId = doc.data().skillsId;
          if (skillId) {
            skillIdsSet.add(skillId);
            skillsCountMap[skillId] = (skillsCountMap[skillId] || 0) + 1;
          }
        });

        const skillCategoriesPromises = Array.from(skillIdsSet).map(async skillId => {
          const q = query(collection(db, "skills_categories"), where("skillsId", "==", skillId));
          const skillSnap = await getDocs(q);
          const skillDoc = skillSnap.docs[0];

          return skillDoc ? {
            id: skillDoc.id,
            ...skillDoc.data(),
            totalPosts: formatCount(skillsCountMap[skillId]) || 0
          } : null;
        });

        const skillscategoriesList = (await Promise.all(skillCategoriesPromises)).filter(Boolean);
        setSkillscategories(skillscategoriesList);
      } catch (error) {
        console.error("Error fetching skill categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSkillscategoriesData();
  }, [selectedSkill]);

  const formatCount = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + "K";
    return num.toString();
  };


  const changeskills = (skillsId) => {
    if (skillsId === "0") {
      setSelectedSkill("0");
      setSelectedjobcategories("0");

      setTimeout(function () {
        // fetchJobtasks("0");
      }, 2000);


    } else {
      setSelectedjobcategories("0");
      setSelectedSkill(skillsId);
      fetchjobcategory(skillsId);
      // fetchJobtasks("0");
    }
  };

  const fetchjobcategory = async (skillsId) => {
    try {
      const q = query(
        collection(db, "postdata"),
        where("skillsId", "==", skillsId),
        where("visibility", "==", true)
      );

      const querySnapshot = await getDocs(q);
      const jobCategoryMap = new Map();

      querySnapshot.forEach(doc => {
        const data = doc.data();
        const jobcategoryId = data.jobcategoryId;
        const jobcategoryName = data.jobcategories;

        if (jobcategoryId) {
          if (!jobCategoryMap.has(jobcategoryId)) {
            jobCategoryMap.set(jobcategoryId, {
              jobcategoryId,
              jobcategories: jobcategoryName || "Unnamed",
              totalPosts: 1
            });
          } else {
            jobCategoryMap.get(jobcategoryId).totalPosts += 1;
          }
        }
      });

      const JobtasksList = Array.from(jobCategoryMap.values());
      setJobcategories(JobtasksList);
    } catch (error) {
      console.error("Error fetching Jobtasks:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async (categories) => {
    setIsLoading(true);
    console.log("Fetching users...");

    try {
const q = query(
  collection(db, "users"),
  where("status", "==", true), 
  where("jobseeker", "==", true),
  orderBy("name", "asc"),
  orderBy("subscriber", "desc")
);
      const querySnapshot = await getDocs(q);

      console.log("Users found:", querySnapshot.docs.length);

      const usersLoginList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const usersWithFollowers = await Promise.all(
        usersLoginList.map(async user => { 
          // Fetch user details
          const detailsQuery = query(
            collection(db, "users_details"),
            where("guid", "==", user.guid)
          );
          const detailsSnapshot = await getDocs(detailsQuery);
          const userDetails = detailsSnapshot.docs.map(doc => doc.data());

          return {
            ...user,
            details: userDetails 
          };
        })
      );

      setUsersData(usersWithFollowers);
      console.log("Users with followers:", usersWithFollowers);
    } catch (error) {
      console.error("Error fetching users or followers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function limitStringLength(str, maxLength) {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + " ..."; // truncate
    }
    return str;
  }

  return (
    <div>
      <Header />
      <div className='app_header_height'></div>

      <div className="container_roots">

        <Helmet>
          <title>Find Editors – Browse Creative Talent | EditorTask</title>
          <meta name="description" content="Connect with talented editors and creative professionals. Browse EditorTask to find the perfect fit for your project." />
          <meta name="keywords" content="find editors, creative talent, hire editors, EditorTask, freelance editors, professional editing" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Find Editors – Browse Creative Talent | EditorTask" />
          <meta property="og:description" content="Discover and connect with skilled editors for your creative projects on EditorTask." />
          <meta property="og:url" content="https://editortask.com/hire-editors" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        </Helmet>

        <div className="container_size">
          <div className='post-container'>
            <div className="contact-title">Discover Editors – Explore Creative Talent | EditorTask</div>
          </div>


          <div className='Skillscategories-body'>
            <div className="categories-grid">
              {isLoading ? (
                <Lodinging />
              ) : (
                <>
                  <div
                    onClick={() => {
                      setSelectedSkill("0");
                      changeskills("0");
                    }}
                    className={`categories ${selectedSkill === "0" ? 'active' : ''}`}
                  >
                    <div className='title-text '
                      style={{ cursor: 'pointer' }}
                    >
                      All

                    </div>
                  </div>

                  {Skillscategories.map((skillscat, index) => (
                    <div onClick={() => changeskills(skillscat.skillsId)}
                      className={`categories ${selectedSkill === skillscat.skillsId ? 'active' : ''}`}
                      key={index}>
                      <div className='title-text'

                        style={{ cursor: 'pointer' }}
                      >
                        {skillscat.title} <a className='count-text'>({skillscat.totalPosts})</a>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>


          <div className='post-container'>
            <div className='post_updates'>
              <div className='jobcategories-body'>
                {isLoading ? (
                  <Lodinging />
                ) : (
                  <>
                    {jobcategories.map((cat, index) => (
                      <div key={index} style={{ cursor: 'pointer' }} onClick={() => fetchUsers(cat.jobcategoryId)}
                        className={`jobcategoriestask ${selectedjobcategories === cat.jobcategoryId ? 'active' : ''}`}
                      >  <div className='category-content' >
                          <div className='title-text'>{cat.jobcategories}</div>
                          <a className='count-text'>({cat.totalPosts})</a>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            <div className='post_div row_body'>
              <div className="editorsui-grid">
                {isLoading ? (
                  <Lodinging /> // 🔁 Is this a typo? Should it be <Loading />?
                ) : (
                  <>
                    {Array.isArray(UsersData) && UsersData.length > 0 ? (
                      UsersData.map((userlist, index) => (
                        <div
                          onClick={() => navigate(`/${userlist.slug}`)}
                          className="editor-items"
                          key={index}
                        >
                          <div className='photo-ui-body' >
                            <div className='cover-ui-div'>
                              {loading && <div className="loading"><Lodinging /></div>}
                              <img
                                className="user-ui-covers-img"
                                src={userlist.cover}
                                alt="cover"
                                onLoad={() => setLoading(false)}
                                onError={() => setLoading(false)} // also hides loader if there's an error
                                style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                              />
                            </div>
                            <div className='photo-ui-div'>
                              <img
                                className='photo-ui-img'
                                src={userlist.photoURL}
                                alt="User"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = Photosicon;
                                }}
                              />
                            </div>
                          </div>
                         <div className='name-div'>
                                <div className='subscriber-btn'><b>{userlist.subscriber}</b> Subscriber</div>
                        
                            <div className="name-text" >
                              {userlist.name}
                            </div>
                            <div className="bio-text" >
                              {limitStringLength(userlist.bio, 40)}
                            </div>
                            <br />
                             </div>
                            <div className='editor-div'>
                              <table className='editor-table' >
                                <tr><td>
                                  <LuBriefcaseBusiness className='eicon' />
                                </td>
                                  <td>

                                    <td className='iteme-text'>
                                      {`${GetCalculateAge(userlist?.work_experience)} yrs Experience`}
                                    </td>
                                  </td>
                                </tr>
                                <tr><td>
                                  <VscCalendar className='icon' />
                                </td>
                                  <td className='iteme-text'>
                                    {`Age: ${GetCalculateAge(userlist?.dob)} years`}
                                  </td>
                                </tr>
                                {/* <tr><td>
                                <MdOutlinePayments className='icon' />
                              </td>
                              <td>
                              {userlist.details.map((detail, index) => (
                                <a className='iteme-text' key={index}>{JSON.stringify(detail)}</a>                                
                              ))}
                             </td>
                               
                              </tr> */}

                                {userlist.country !== "no" && (
                                  <tr>
                                    <td>
                                      <CiLocationOn className='eicon' />
                                    </td>
                                    <td>
                                      <a className='iteme-text'>{userlist.country}</a>
                                    </td>
                                  </tr>

                                )}
                                 <tr><td>
                                  <VscCalendar className='eicon' />
                                </td>
                                  <td className='iteme-text'>
                                    {`Join:  ${GetAgoTime(userlist.datetime)} `}
                                  </td>
                                </tr>
                              </table>
                            </div>
                         
                          <div className='contact-us-div'>
                         
                            <div className='contact-btn'>
                              <div className='button-ui'><BiChat className='icon' /> Contact Us</div>
                            </div>

                          </div>

                        </div>
                      ))
                    ) : (
                      <p>No users found.</p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
      <Navbar/>
      <Footer/>
    </div>
  );
}
